import React, { useState, useEffect } from 'react';
import { Button, Grid, makeStyles, TableBody, TableCell, TableRow, TextField } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import moment from 'moment';
import swal from '@sweetalert/with-react';

import axiosInstance, { EVENT_CODE, EVENT_ID, saveDeadline, WEB_API } from '../constatns';
import Table from '../components/Table/Table';
import SubTitle from '../components/Text/SubTitle';

const useStyles = makeStyles((theme) => ({
  tableBody: {
    '& tr': {
      '&>td': {
        textAlign: 'center',
      },
      '&>td:nth-child(1)': {
        width: '22.5%',
      },
      '&>td:nth-child(2)': {
        width: '40%',
      },
      '&>td:nth-child(3)': {
        width: '25%',
      },
      '&>td:nth-child(4)': {
        width: '12.5%',
      },
    },
  },
}));

const KeyDates = (props) => {
  const { history } = props;
  const classes = useStyles();
  const EVT = JSON.parse(sessionStorage.getItem('EVENT'));

  const [keyDates, setKeyDates] = useState();

  const [paperDeadlineTitle, setPaperDeadlineTitle] = useState(EVT && EVT.paperDeadlineTitle ? EVT.paperDeadlineTitle : '');
  const [abstractAcceptanceTitle, setAbstractAcceptanceTitle] = useState(
    EVT && EVT.abstractAcceptanceTitle ? EVT.abstractAcceptanceTitle : '',
  );
  const [ealrybirdRegistrationTitle, setEalrybirdRegistrationTitle] = useState(EVT && EVT.regDeadlineTitle ? EVT.regDeadlineTitle : '');
  const [regularRegistrationTitle, setRegularRegistrationTitle] = useState(EVT && EVT.regDeadline2Title ? EVT.regDeadline2Title : '');
  // const [onsiteRegistrationTitle, setOnsiteRegistrationTitle] = useState(EVT && EVT.regDeadline2Title ? EVT.regDeadline2Title : '');

  const [paperDeadline, setPaperDeadline] = useState(
    EVT && EVT.paperDeadline ? EVT.paperDeadline : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );
  const [abstractAcceptance, setAbstractAcceptance] = useState(
    EVT && EVT.abstractAcceptance ? EVT.abstractAcceptance : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );
  const [ealrybirdRegistration, setEalrybirdRegistration] = useState(
    EVT && EVT.regDeadline ? EVT.regDeadline : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );
  const [regularRegistration, setRegularRegistration] = useState(
    EVT && EVT.regDeadline2 ? EVT.regDeadline2 : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );
  const [onsiteRegistration, setOnsiteRegistration] = useState(
    EVT && EVT.regOnsiteDeadline ? EVT.regOnsiteDeadline : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );

  // useEffect(() => {
  //   let buff = EVT.keyDates;
  //   // let buff = [];
  //   console.log(EVT.keyDates);
  //   for (const [key, value] of Object.entries(EVT)) {
  //     for (let i = 0; i < buff.length; i++) {
  //       if (key === buff[i].deadlineKey) {
  //         // console.log(key + ' : ' + value);
  //         buff[i]['deadline'] = value;
  //       }
  //     }
  //   }
  //   // console.log(buff);
  //   setKeyDates(buff);
  // }, []);

  const doSaveTitle = (key, value) => {
    saveDeadline(key, value);
  };

  const doSavePaperDeadline = () => {
    doSaveTitle(paperDeadlineTitle, 'paperDeadlineTitle');
    saveDeadline(paperDeadline, 'paperDeadline');
  };

  const doSaveAbstractAcceptance = () => {
    doSaveTitle(abstractAcceptanceTitle, 'abstractAcceptanceTitle');
    saveDeadline(abstractAcceptance, 'abstractAcceptance');
  };

  const doSaveEalrybirdRegistration = () => {
    doSaveTitle(ealrybirdRegistrationTitle, 'regDeadlineTitle');
    saveDeadline(ealrybirdRegistration, 'regDeadline');
  };

  const doSaveRegularRegistration = () => {
    doSaveTitle(regularRegistrationTitle, 'regDeadline2Title');
    saveDeadline(regularRegistration, 'regDeadline2');
  };

  const doSaveOnlineRegistration = () => {
    saveDeadline(onsiteRegistration, 'regOnsiteDeadline');
  };

  return (
    <>
      {/*
            1. Deadline for Free Paper -> 2021.08.13(Fri)
            2. Notification of Abstract Acceptance -> 2021.09.06(Mon)
            3. Deadline for Ealry-bird Registration -> 2021.08.31(Tue)
            4. Deadline for Regular Registration -> 2021.10.31(Sun)
        */}

      <Grid container alignItems={'center'} justifyContent={'center'}>
        <Grid item xs={8}>
          <SubTitle isDecoHidden={true}>Key Dates Setting for Main Page</SubTitle>
          <Table>
            <TableBody className={classes.tableBody}>
              {/* 1. Deadline for Free Paper */}
              <TableRow>
                <TableCell>초록 마감 등록 일시</TableCell>
                <TableCell>
                  <TextField
                    type="text"
                    fullWidth
                    defaultValue={paperDeadlineTitle}
                    onChange={(e) => setPaperDeadlineTitle(e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue={paperDeadline}
                    onChange={(e) => setPaperDeadline(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Button color="secondary" variant={'outlined'} startIcon={<SaveIcon />} onClick={doSavePaperDeadline} disableElevation>
                    저장
                  </Button>
                </TableCell>
              </TableRow>

              {/* 2. Notification of Abstract Acceptance */}
              <TableRow>
                <TableCell>초록 승인 알림 일시</TableCell>
                <TableCell>
                  <TextField
                    type="text"
                    fullWidth
                    defaultValue={abstractAcceptanceTitle}
                    onChange={(e) => setAbstractAcceptanceTitle(e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue={abstractAcceptance}
                    onChange={(e) => setAbstractAcceptance(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={doSaveAbstractAcceptance}
                    disableElevation
                  >
                    저장
                  </Button>
                </TableCell>
              </TableRow>

              {/* 3. Deadline for Ealry-bird Registration */}
              <TableRow>
                <TableCell>1차 사전등록 마감 일시</TableCell>
                <TableCell>
                  <TextField
                    type="text"
                    fullWidth
                    defaultValue={ealrybirdRegistrationTitle}
                    onChange={(e) => setEalrybirdRegistrationTitle(e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue={ealrybirdRegistration}
                    onChange={(e) => setEalrybirdRegistration(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={doSaveEalrybirdRegistration}
                    disableElevation
                  >
                    저장
                  </Button>
                </TableCell>
              </TableRow>

              {/* 4. Deadline for Regular Registration */}
              <TableRow>
                <TableCell>2차 사전등록 마감 일시</TableCell>
                <TableCell>
                  <TextField
                    type="text"
                    fullWidth
                    defaultValue={regularRegistrationTitle}
                    onChange={(e) => setRegularRegistrationTitle(e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue={regularRegistration}
                    onChange={(e) => setRegularRegistration(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={doSaveRegularRegistration}
                    disableElevation
                  >
                    저장
                  </Button>
                </TableCell>
              </TableRow>

              {/* 5. Deadline for Onsite Registration */}
              <TableRow>
                <TableCell>현장등록 마감 일시</TableCell>
                <TableCell>
                  <TextField type="text" fullWidth disabled defaultValue={'Deadline for Onsite Registration'} />
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue={onsiteRegistration}
                    onChange={(e) => setOnsiteRegistration(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Button
                    color="secondary"
                    variant={'outlined'}
                    startIcon={<SaveIcon />}
                    onClick={doSaveOnlineRegistration}
                    disableElevation
                  >
                    저장
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
};

export default KeyDates;
